import { render, staticRenderFns } from "./AccessGuide.vue?vue&type=template&id=6ffd1485&scoped=true"
import script from "./AccessGuide.vue?vue&type=script&lang=js"
export * from "./AccessGuide.vue?vue&type=script&lang=js"
import style0 from "./AccessGuide.vue?vue&type=style&index=0&id=6ffd1485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd1485",
  null
  
)

export default component.exports